import { EventData } from "./event-data";
import { InvitationStatusEnum } from "./invitation";
import { UserInfo } from "./user";

export type PdvSalesScope = "portaria_only" | "advance_and_portaria";
export type CoordinatorProfile = "approver_only" | "also_operates";
export type CashLimitAction = "notify_only" | "block_sales";

export interface PdvAccessSettings {
  role: CollaboratorRoleEnum;
  coordinator_profile?: CoordinatorProfile;
  pdv_sales_scope?: PdvSalesScope;
  gives_pin?: boolean;
  sales_limit_cents?: number | null;
  cash_limit_action?: CashLimitAction;
  reset_pin?: boolean;
}

export interface CollaboratorMutationResponse {
  message?: string;
  pin?: string | null;
}

export interface PdvAccessMetadata {
  cash_limit_action?: CashLimitAction;
  coordinator_profile?: CoordinatorProfile | null;
  gives_pin?: boolean;
  sales_limit_cents?: number | null;
  pin_set?: boolean;
}

export interface AddCollaboratorDTO {
  collaborator: {
    email: string;
    role: CollaboratorRoleEnum;
    user_phone_number: string;
    pdv_sales_scope?: PdvSalesScope;
    coordinator_profile?: CoordinatorProfile;
    gives_pin?: boolean;
    sales_limit_cents?: number | null;
    cash_limit_action?: CashLimitAction;
  };
}

export interface Collaborator extends PdvAccessMetadata {
  pdv_sales_scope?: PdvSalesScope;
  id: number;
  email: string;
  role: CollaboratorRoleEnum;
  phone: string;
  name: string;
  last_name: string;
  user_id: number;
}

export interface CollaboratorInvitation extends PdvAccessMetadata {
  pdv_sales_scope?: PdvSalesScope;
  id: number;
  email: string;
  event_id: number;
  role: CollaboratorRoleEnum;
  token: string;
  accepted_at: Date;
  expires_at: Date;
  status: InvitationStatusEnum;
  phone: string;
  event_title?: string;
  event: EventData;
}

export interface CollaboratorInvitationAcceptanceResponse {
  message: string;
  user: UserInfo;
}

export enum CollaboratorRoleEnum {
  MANAGER = "manager",
  DOORPERSON = "doorperson",
  POINT_OF_SALE = "point_of_sale",
  SELLER = "seller",
  MARKETING = "marketing",
  OBSERVER = "observer",
  PDV_PORTARIA = "pdv_portaria",
  PDV_PORTARIA_COORDINATOR = "pdv_portaria_coordenador",
}

export enum ChannelEnum {
  EMAIL = "EMAIL",
  WHATSAPP = "WHATSAPP",
  SMS = "SMS",
}
